import type { Action } from 'state/actions';
import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import type { CancellationState } from 'state/secondaryMarket/shared/cancellation/cancellation.model';
import { initialCancellationState } from 'state/secondaryMarket/shared/cancellation/cancellation.model';
import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

export function cancellationReducerFactory(actionType: OrderActionType) {
  return (state: CancellationState = initialCancellationState(), action: Action): CancellationState => {
    switch (action.type) {
      case `SECONDARY_MARKET_${actionType}_CANCELLATION_WORKFLOW_INIT` as const:
        return addOrReplaceKey(state, action.orderId, { status: 'INIT' as const });
      case `SECONDARY_MARKET_${actionType}_CANCELLATION_WORKFLOW_ABORTED` as const:
        return removeKey(state, action.orderId);
      case `SECONDARY_MARKET_${actionType}_CANCELLATION_WORKFLOW_COMPLETED` as const:
        return removeKey(state, action.orderId);
      case `SECONDARY_MARKET_${actionType}_CANCELLATION_REQUESTED` as const:
        return patchKey(state, action.orderId, () => ({ status: 'IN_PROGRESS' as const }));
      case `SECONDARY_MARKET_${actionType}_CANCELLATION_RECEIVED` as const:
        return patchKey(state, action.orderId, () => ({ status: 'SUCCESS' as const }));
      case `SECONDARY_MARKET_${actionType}_CANCELLATION_FAILED` as const:
        return patchKey(state, action.orderId, () => ({ status: 'FAILED' as const, error: action.error }));
      case `SECONDARY_MARKET_${actionType}_CANCELLATION_REJECTED` as const:
        return patchKey(state, action.orderId, () => ({ status: 'REJECTED' as const, error: action.error }));
      default:
        return state;
    }
  };
}
